/**
 * api/content.js — Content Pieces CRUD
 *
 * GET    /api/content-pieces
 * GET    /api/content-pieces/calendar
 * POST   /api/content-pieces
 * PUT    /api/content-pieces/:id
 * DELETE /api/content-pieces/:id
 */

import client from './client';

export const contentApi = {

  async getAll(params = {}) {
    const { data } = await client.get('/content-pieces', { params });
    return data.data ?? data;
  },

  async getCalendar(params = {}) {
    const { data } = await client.get('/content-pieces/calendar', { params });
    return data.data ?? data;
  },

  async create(payload) {
    const { data } = await client.post('/content-pieces', { pieces: [payload] });
    const result = data.data ?? data;
    return Array.isArray(result) ? result[0] : result;
  },

  async createBulk(payloads) {
    const { data } = await client.post('/content-pieces', { pieces: payloads });
    return data.data ?? data;
  },

  async update(id, payload) {
    const { data } = await client.put(`/content-pieces/${id}`, payload);
    return data.data ?? data;
  },

  async remove(id) {
    await client.delete(`/content-pieces/${id}`);
  },

  /** Convenience: schedule a piece (sets scheduled_date + status). */
  async schedule(id, scheduledDate) {
    return this.update(id, { scheduled_date: scheduledDate, status: 'scheduled' });
  },

  /** Convenience: remove a piece from the schedule. */
  async unschedule(id) {
    return this.update(id, { scheduled_date: null, status: 'approved' });
  },
};
